import LuxuryEscapesSmallLogo from 'components/App/Header/Logo/logos/LuxuryEscapesSmallLogo'
import { rem } from 'polished'
import styled from 'styled-components'

const Container = styled.div`
  height: ${rem(24)};
  width: ${rem(34)};
  border-radius: ${props => props.theme.borderRadius.M};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: ${props => props.theme.palette.neutral.default.one};
`

const Logo = styled(LuxuryEscapesSmallLogo)`
  path {
    fill: ${props => props.theme.palette.neutral.default.eight};
  }
`

function LEGiftCardIcon() {
  return (
    <Container>
      <Logo height={rem(12)} width={rem(12)} />
    </Container>
  )
}

export default LEGiftCardIcon
